import { Component, ViewChild, inject, signal } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { AsyncPipe, NgClass } from '@angular/common';
import { MatError } from '@angular/material/form-field';
import { take } from 'rxjs';
import { MatCheckbox } from '@angular/material/checkbox';
import { FormBuilder, NgForm, Validators, ReactiveFormsModule } from '@angular/forms';

import { NewsletterService, TranslateDirective, TranslatePipe } from '@speedy/core';

import { BlockComponent } from '../../block/block.component';
import { SpeedyButtonComponent } from '../../speedy-button/speedy-button.component';

@Component({
  selector: 'app-newsletter',
  templateUrl: './newsletter.component.html',
  styleUrls: ['./newsletter.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgClass,
    SpeedyButtonComponent,
    MatError,
    MatCheckbox,
    BlockComponent,
    TranslatePipe,
    TranslateDirective,
    AsyncPipe,
  ],
})
export class NewsletterComponent {
  @ViewChild('newsletterForm') newsletterFormRef!: NgForm;

  private readonly fb = inject(FormBuilder);
  private readonly alertService = inject(ToastrService);
  private readonly newsletterService = inject(NewsletterService);

  newsLetterForm = this.fb.group({
    newsletter: this.fb.control('', [Validators.required, Validators.email]),
    agree: this.fb.control(false, Validators.requiredTrue),
  });

  loading = signal(false);

  subscribe() {
    if (this.newsLetterForm.invalid) {
      this.newsLetterForm.markAllAsTouched();
      return;
    }
    this.loading.set(true);

    const value = this.newsLetterForm.getRawValue();

    this.newsletterService
      .subscribeToNewsletter(value.newsletter as string)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.loading.set(false);
          this.newsletterFormRef.resetForm();
          if (response.valid && response.messages?.length) {
            this.alertService.success(response.messages[0]);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.loading.set(false);
          if (error?.error.message) {
            this.alertService.error(error.error.message);
          } else {
            this.alertService.error('Could not subscribe your email');
          }
        },
      });
  }
}
